<!-- Loader Spinner -->

<c-card class="mb-4 shadow-lg">
  <c-card-body>
    <div
      *ngIf="isLoading"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 300px"
    >
      <c-spinner size="lg" color="primary"></c-spinner>
    </div>
    <c-row [hidden]="isLoading">
      <c-col sm="12">
        <h4 class="card-title mb-0" id="traffic">Plans</h4>
        <hr />

        <!-- Current Package Status Display -->
        <!-- <div *ngIf="hasActiveLicense" class="mb-4">
          <div class="card border-left-primary shadow">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col">
                  <div class="small text-muted">Current Package</div>
                  <div class="h6 mb-1">
                    <span [class]="getCurrentPackageBadgeClass()">
                      <i [class]="getCurrentPackageIcon()"></i>
                      {{ getCurrentPackageDisplayName() }}
                    </span>
                    <span *ngIf="currentPackageType === 'demo'" class="text-warning ms-2">
                      <i class="fa fa-clock"></i> Trial
                    </span>
                  </div>
                  <div *ngIf="getCurrentLicensedFeatures().length > 0" class="small text-muted">
                    Features: 
                    <span *ngFor="let feature of getCurrentLicensedFeatures(); let last = last">
                      {{ feature }}<span *ngIf="!last">, </span>
                    </span>
                  </div>
                  <div *ngIf="isextraStore" class="small text-info">
                    <i class="fa fa-store"></i> RMH Central with {{ extraNOS || 0 }} additional store(s)
                  </div>
                </div>
                <div class="col-auto">
                  <i [class]="getCurrentPackageIcon()" class="fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="container">
          <c-row>
            <c-col sm="3" [hidden]="true">
              <label for="selectUser">User</label>
              <div class="form-group mt-2">
                <select id="selectUser" class="form-control" disabled>
                  <option selected [value]="UserData.id">
                    {{ UserData.userDisplayName }}
                  </option>
                </select>
              </div>
            </c-col>
            <c-col sm="3">
              <label for="selectproduct">Product</label>
              <div class="form-group mt-2">
                <select
                  id="selectproduct"
                  class="form-control"
                  cSelect
                  (change)="GetFeatureList($event.target.value)"
                  [disabled]="selectedProductId || (hasActiveLicense && currentPackageType !== 'demo')"
                >
                  <option>Select Product</option>
                  <option
                    *ngFor="let prodata of ProductsData"
                    [value]="prodata.id"
                    [selected]="prodata.id == selectedProductId"
                  >
                    {{ prodata.productName }}
                  </option>
                </select>
              </div>
            </c-col>
            <c-col sm="3" *ngIf="IsAllowedCentral && !IsRMH && hasActiveLicense && isextraStore">
              <div class="mt-3">
                <label class="form-label fw-bold text-primary mb-2">
                </label>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="rmhCentralCheckbox"
                    [(ngModel)]="isextraStore"
                    (change)="enablees()"
                    [disabled]="true"
                  />
                  <label class="form-check-label text-primary mb-2" for="rmhCentralCheckbox">
                  <i class="fa fa-store me-2"></i>RMH Central
                  </label>
                </div>
              </div>
            </c-col>
            <c-col sm="3" *ngIf="IsProductSelected && IsRMH" class="mt-5">
              <c-form-check [switch]="true">
                <input
                cFormCheckInput
                type="checkbox"
                [(ngModel)]="IsRMH"
                disabled
              />
              RMS
              </c-form-check>
              
              </c-col>
            <c-col sm="6">
              <div
                *ngIf=" IsAllowedCentral && hasActiveLicense && isextraStore"
                class="alert alert-info py-2 mb-2 mt-4"
              >
                <i class="fa fa-info-circle me-2"></i>
                One store is included with RMH Central. Enter Additional stores.
              </div>
            </c-col>
            <c-col sm="12">
              <!-- <div *ngIf="msg">
                    <div [innerHTML]="msg"></div>
                  </div> -->
              <div
                class="mt-2"
                *ngIf="durationoptionselected && taskList != '' && false"
              >
                <table cTable cTableColor="info">
                  <thead cTableColor="dark">
                    <tr>
                      <td><b> Modules and Features List </b></td>
                      <td align="right" style="width: 130px">
                        <b> Monthly </b>
                      </td>
                      <td
                        *ngIf="IsAllowedCentral && hasActiveLicense && isextraStore"
                        align="right"
                        style="width: 150px"
                      >
                        <b> Additional Store </b>
                      </td>
                      <td align="right" style="width: 130px">
                        <b> One Time </b>
                      </td>
                      <td align="right" style="width: 130px"><b> Total </b></td>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let module of taskList">
                      <tr>
                        <th>
                          {{ module.moduleName }}
                        </th>
                        <td></td>
                        <td></td>

                        <td *ngIf="IsAllowedCentral && hasActiveLicense && isextraStore"></td>
                        <td></td>
                      </tr>
                      <ng-container *ngFor="let feature of module.featureList">
                        <tr
                          [class.table-success]="
                            isFeatureLicensed(feature.featureName)
                          "
                          [class.text-success]="
                            isFeatureLicensed(feature.featureName)
                          "
                        >
                          <td style="padding-left: 60px">
                            <input
                              type="checkbox"
                              [(ngModel)]="feature.selected"
                              (change)="handleCheckboxChange(feature)"
                              [disabled]="hasActiveLicense && currentPackageType !== 'demo'"
                            />
                            {{ feature.featureName }}
                            <span *ngIf="feature.isServiceItem">
                              (Service Item)</span
                            >
                            <span
                              *ngIf="isFeatureLicensed(feature.featureName)"
                              class="badge badge-success ms-2"
                            >
                              <i class="fa fa-check"></i> Current
                            </span>
                          </td>
                          <td align="right">
                            {{ feature.price | currency }}
                          </td>
                          <td align="right" *ngIf="IsAllowedCentral && hasActiveLicense && isextraStore">
                            {{ feature.price_ExtraStore | currency }}
                          </td>
                          <td align="right">
                            {{ feature.price_OneTime | currency }}
                          </td>
                          <td>
                            <!-- {{featureTotalPrice | currency}} -->
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>

                    <tr style="border-top: 3px solid black">
                      <td>
                        <h6>Total Billable To Client</h6>
                      </td>
                      <td align="right">
                        <h6>
                          {{
                            this.totaloffeatureprice - this.serviceitemonthly
                              | currency
                          }}
                        </h6>
                      </td>

                      <td align="right" *ngIf="IsAllowedCentral && hasActiveLicense && isextraStore">
                        <h6>
                          {{
                            storewithduration -
                              serviceitemadditionalwithduration | currency
                          }}
                        </h6>
                      </td>
                      <td align="right">
                        <h6>
                          {{
                            totalofonetimeprice - totalofserviceitemonetime
                              | currency
                          }}
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          {{
                            totalPrice +
                              storewithduration -
                              totalofserviceitemonetime -
                              this.serviceitemonthly -
                              serviceitemadditionalwithduration | currency
                          }}
                        </h6>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <h6>Partner Margin ({{ partnerpercentage }}%)</h6>
                      </td>
                      <td align="right">
                        <h6>
                          ({{
                            (this.totaloffeatureprice -
                              this.serviceitemonthly) *
                              (partnerpercentage / 100) | currency
                          }})
                        </h6>
                      </td>

                      <td align="right" *ngIf="IsAllowedCentral && hasActiveLicense && isextraStore">
                        <h6>
                          ({{
                            (storewithduration -
                              serviceitemadditionalwithduration) *
                              (partnerpercentage / 100) | currency
                          }})
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          ({{
                            (totalofonetimeprice - totalofserviceitemonetime) *
                              (partnerpercentage / 100) | currency
                          }})
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          ({{
                            (totalPrice +
                              storewithduration -
                              totalofserviceitemonetime -
                              this.serviceitemonthly -
                              serviceitemadditionalwithduration) *
                              (partnerpercentage / 100) | currency
                          }})
                        </h6>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <h6>Total of Service Items</h6>
                      </td>
                      <td align="right">
                        <h6>{{ this.serviceitemonthly | currency }}</h6>
                      </td>

                      <td align="right" *ngIf="IsAllowedCentral && hasActiveLicense && isextraStore">
                        <h6>
                          {{ serviceitemadditionalwithduration | currency }}
                        </h6>
                      </td>
                      <td align="right">
                        <h6>{{ totalofserviceitemonetime | currency }}</h6>
                      </td>

                      <td align="right">
                        <h6>
                          {{
                            this.serviceitemonthly +
                              serviceitemadditionalwithduration +
                              totalofserviceitemonetime | currency
                          }}
                        </h6>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <h6>
                          Service Item Margin ({{ serviceItemDiscount }}%)
                        </h6>
                      </td>
                      <td align="right">
                        <h6>
                          ({{
                            this.serviceitemonthly * (serviceItemDiscount / 100)
                              | currency
                          }})
                        </h6>
                      </td>

                      <td align="right" *ngIf="IsAllowedCentral && hasActiveLicense && isextraStore">
                        <h6>
                          ({{
                            serviceitemadditionalwithduration *
                              (serviceItemDiscount / 100) | currency
                          }})
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          ({{
                            totalofserviceitemonetime *
                              (serviceItemDiscount / 100) | currency
                          }})
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          ({{
                            (this.serviceitemonthly +
                              serviceitemadditionalwithduration +
                              totalofserviceitemonetime) *
                              (serviceItemDiscount / 100) | currency
                          }})
                        </h6>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h6>Net Payable By Partner</h6>
                      </td>

                      <td align="right">
                        <h6>
                          {{
                            this.totaloffeatureprice -
                              this.serviceitemonthly -
                              (this.totaloffeatureprice -
                                this.serviceitemonthly) *
                                (partnerpercentage / 100) +
                              (this.serviceitemonthly -
                                this.serviceitemonthly *
                                  (serviceItemDiscount / 100)) | currency
                          }}
                        </h6>
                      </td>
                      <td align="right" *ngIf="IsAllowedCentral && hasActiveLicense && isextraStore">
                        <h6>
                          {{
                            storewithduration -
                              serviceitemadditionalwithduration -
                              (storewithduration -
                                serviceitemadditionalwithduration) *
                                (partnerpercentage / 100) +
                              (serviceitemadditionalwithduration -
                                serviceitemadditionalwithduration *
                                  (serviceItemDiscount / 100)) | currency
                          }}
                        </h6>
                      </td>

                      <td align="right">
                        <h6>
                          {{
                            totalofonetimeprice -
                              totalofserviceitemonetime -
                              (totalofonetimeprice -
                                totalofserviceitemonetime) *
                                (partnerpercentage / 100) +
                              (totalofserviceitemonetime -
                                totalofserviceitemonetime *
                                  (serviceItemDiscount / 100)) | currency
                          }}
                        </h6>
                      </td>
                      <td align="right">
                        <h6>
                          {{
                            this.totaloffeatureprice -
                              this.serviceitemonthly -
                              (this.totaloffeatureprice -
                                this.serviceitemonthly) *
                                (partnerpercentage / 100) +
                              (this.serviceitemonthly -
                                this.serviceitemonthly *
                                  (serviceItemDiscount / 100)) +
                              (storewithduration -
                                serviceitemadditionalwithduration -
                                (storewithduration -
                                  serviceitemadditionalwithduration) *
                                  (partnerpercentage / 100) +
                                (serviceitemadditionalwithduration -
                                  serviceitemadditionalwithduration *
                                    (serviceItemDiscount / 100))) +
                              (totalofonetimeprice -
                                totalofserviceitemonetime -
                                (totalofonetimeprice -
                                  totalofserviceitemonetime) *
                                  (partnerpercentage / 100) +
                                (totalofserviceitemonetime -
                                  totalofserviceitemonetime *
                                    (serviceItemDiscount / 100))) | currency
                          }}
                        </h6>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <input type="checkbox" [(ngModel)]="isBillToClient" [disabled]="hasActiveLicense && currentPackageType !== 'demo'" /> Bill To
                Client <br />

                <button
                  type="submit"
                  class="btn btn-primary px-4 mb-3 mt-2"
                  style="margin: auto"
                  [disabled]="ButtonLoading || (hasActiveLicense && currentPackageType !== 'demo')"
                  (click)="updateAllTasks()"
                >
                  <c-spinner
                    aria-hidden="true"
                    size="sm"
                    *ngIf="ButtonLoading"
                  ></c-spinner>
                  Buy Now
                </button>
              </div>

              <!-- ---------------------------------------------------------------------------------------------------------------------------- -->
              <div
                class="mt-4"
                *ngIf="durationoptionselected && taskList != ''"
              >
                <!-- Duration Toggle Buttons - Modern Design -->
                <div class="mb-2 text-center">
                  <div class="d-inline-flex rounded-pill p-2" style="background: linear-gradient(135deg, #f5f5f5 0%, #fafafa 100%); border: 1px solid #e0e0e0; box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);">
                    <ng-container *ngFor="let duration of getFilteredDurationOptions(); let last = last">
                      <input 
                        type="radio" 
                        class="btn-check" 
                        name="duration" 
                        [id]="'duration_' + duration.id" 
                        [checked]="selectedDuration?.id === duration.id"
                        (change)="onDurationToggle(duration)"
                        [disabled]="hasActiveLicense && currentPackageType !== 'demo'"
                      />
                      <label 
                        class="btn px-5 py-2 fw-semibold"
                        [class.btn-primary]="selectedDuration?.id === duration.id"
                        [class.btn-text-muted]="selectedDuration?.id !== duration.id"
                        [for]="'duration_' + duration.id"
                        style="
                          border: none;
                          border-radius: 50px;
                          font-size: 0.95rem;
                          letter-spacing: 0.3px;
                          cursor: pointer;
                          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                          color: #666;
                          min-width: 160px;
                          position: relative;
                          overflow: hidden;
                        "
                        [style.background]="selectedDuration?.id === duration.id ? 'linear-gradient(135deg, #007bff 0%, #0056b3 100%)' : 'transparent'"
                        [style.color]="selectedDuration?.id === duration.id ? '#fff' : '#666'"
                        [style.box-shadow]="selectedDuration?.id === duration.id ? '0 4px 12px rgba(0, 123, 255, 0.4)' : 'none'"
                      >
                        <span *ngIf="!duration.isTrial" class="d-flex align-items-center justify-content-center gap-1">
                          <i class="fa" [class.fa-calendar]="!selectedDuration?.id === duration.id" [class.fa-check-circle]="selectedDuration?.id === duration.id"></i>
                          {{ duration.optionTitle }}
                          <span *ngIf="getDiscountPercentageForDuration(duration) > 0" class="badge" [style.background]="selectedDuration?.id === duration.id ? 'rgba(255,255,255,0.3)' : '#fff3cd'" [style.color]="selectedDuration?.id === duration.id ? '#fff' : '#664d03'">
                            -{{ getDiscountPercentageForDuration(duration) | number:'1.0-0' }}%
                          </span>
                        </span>
                        <span *ngIf="duration.isTrial" class="d-flex align-items-center justify-content-center gap-1">
                          <i class="fa fa-gift"></i>
                          {{ duration.optionTitle }}
                          <span class="badge bg-success" style="background: rgba(255,255,255,0.3) !important; color: #fff;">Free</span>
                        </span>
                      </label>
                    </ng-container>
                  </div>
                </div>

                <!-- Current Package Status Banner -->
                <!-- <div
                  *ngIf="hasActiveLicense"
                  class="alert alert-info mb-4 d-flex align-items-center"
                  [class.alert-warning]="shouldDisableControls()"
                >
                  <i class="fa" [class.fa-info-circle]="!shouldDisableControls()" [class.fa-lock]="shouldDisableControls()" style="margin-right: 0.5rem;"></i>
                  <div>
                    <strong
                      >Current Active Package:
                      {{ getCurrentPackageDisplayName() }}</strong
                    >
                    <span
                      *ngIf="currentPackageType === 'demo'"
                      class="ms-2 badge bg-success"
                      >Active</span
                    >
                    <div *ngIf="shouldDisableControls()" class="small text-muted mt-1">
                      Duration, Plan selection, and Product selection are disabled. {{ getDisabledReason() }}
                    </div>
                  </div>
                </div> -->

                <!-- Upgrade/Downgrade Note for Non-Demo Users -->
                <div
                  *ngIf="hasActiveLicense && currentPackageType !== 'demo'"
                  class="alert alert-warning mb-4"
                >
                  <i class="fa fa-exclamation-triangle me-2"></i>
                  <strong>Note:</strong> For upgrades and downgrades to your license, please visit the <a routerLink="/subscriptions" class="alert-link">Subscriptions</a> page.
                </div>

                <div class="row g-4">
                  <!-- Dynamic Plan Cards -->
                  <ng-container *ngIf="planLoading">
                    <div class="col-12">
                      <div class="d-flex align-items-center justify-content-center py-4 text-primary">
                        <c-spinner size="sm" class="me-2"></c-spinner>
                        <span>Loading plans...</span>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="!planLoading && productPlans.length > 0">
                    <div class="col-md-4" *ngFor="let plan of productPlans">
                      <div
                        class="card h-100 p-4 text-start d-flex flex-column card-shadow-lg"
                        [ngClass]="{
                          'border-success border-2': selectedPlanId === plan.id
                        }"
                        style="
                          border-radius: 16px;
                          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                          min-height: 350px;
                        "
                      >
                        <h4 class="mb-2 fw-bold d-flex align-items-center">
                          <i class="fa fa-layer-group me-1"></i>
                          <span>{{ plan.planName }}</span>
                          <span
                            *ngIf="selectedPlanId === plan.id"
                            class="badge bg-success ms-2"
                            >Selected</span
                          >
                        </h4>

                        <div class="fs-2 fw-bold">
                          <span *ngIf="!plan.isDemo">{{ getPlanTotal(plan) | currency }}</span>
                          <span *ngIf="plan.isDemo">Free</span>
                          <span
                            *ngIf="
                              selectedDuration?.duration &&
                              selectedDuration?.chargeDuration &&
                              selectedDuration.duration !==
                                selectedDuration.chargeDuration &&
                              !plan.isDemo
                            "
                            class="ms-2"
                          >
                            <small
                              class="fs-6"
                              style="text-decoration: line-through; color: #888"
                            >
                              {{ getPlanRealTotal(plan) | currency }}
                            </small>
                          </span>
                        </div>
                        <div
                          *ngIf="extraNOS > 0 && IsAllowedCentral"
                          class="fs-6 fw-normal"
                        >
                          <span *ngIf="!plan.isDemo">+ {{ getPlanAdditionalStorePrice(plan) | currency }}</span>
                          <span *ngIf="plan.isDemo">+ $0.00</span>
                          for {{ extraNOS }} additional store(s)
                        </div>
                        <div class="mt-3" *ngIf="isextraStore">
                          <label class="form-label fw-bold">Additional Stores</label>
                          <div class="d-flex align-items-center">
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-secondary me-2"
                              (click)="decreaseStores()"
                              [disabled]="extraNOS <= 0 || (hasActiveLicense && currentPackageType !== 'demo')"
                            >
                              <i class="fa fa-minus"></i>
                            </button>
                            <span class="fw-normal fs-6 mx-2">{{ extraNOS || 0 }}</span>
                            <button
                              type="button"
                              class="btn btn-sm btn-outline-secondary ms-2"
                              (click)="increaseStores()"
                              [disabled]="hasActiveLicense && currentPackageType !== 'demo'"
                            >
                              <i class="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>
                        <hr />

                        <div class="text-start">
                          <ul class="list-unstyled ms-3">
                            <li
                              *ngFor="let detail of plan.details"
                              class="d-flex align-items-center"
                            >
                              <i
                                class="fa"
                                [ngClass]="
                                  detail.isServiceItem
                                    ? 'fa-circle text-secondary me-2'
                                    : 'fa-check-circle text-success me-2'
                                "
                              ></i>
                              <div class="flex-grow-1">
                                <span class="fw-semibold">{{ detail.featureName }}</span>
                                <div class="text-muted small" *ngIf="detail.moduleName">
                                  {{ detail.moduleName }}
                                </div>
                                <div class="text-muted small" *ngIf="plan.transactionTitle && detail.transactionLimit">
                                  <i class="fa fa-exchange me-1"></i>{{ plan.transactionTitle }}: <span class="fw-semibold">{{ detail.transactionLimit == 0 ? ' Unlimited' : detail.transactionLimit }}</span>
                                </div>
                              </div>
                              <div class="ms-2 text-end">
                                <span *ngIf="!plan.isDemo" class="badge bg-light text-dark">{{ detail.price | currency }}</span>
                                <span
                                  *ngIf="detail.priceExtraStore && extraNOS > 0 && !plan.isDemo"
                                  class="badge bg-warning text-dark ms-1"
                                >
                                  +{{ (detail.priceExtraStore * extraNOS) | currency }}
                                  /{{ extraNOS }} store(s)
                                </span>
                                <span
                                  *ngIf="detail.priceOneTime && !plan.isDemo"
                                  class="badge bg-info text-dark ms-1"
                                >
                                  +{{ detail.priceOneTime | currency }} One-Time
                                </span>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="mt-auto">
                          <button
                          *ngIf="!plan.isDemo"
                            class="btn w-100"
                            [ngClass]="
                              plan.isDemo
                                ? 'btn-secondary'
                                : selectedPlanId === plan.id
                                  ? 'btn-success'
                                  : 'btn-outline-primary'
                            "
                            (click)="choosePlan(plan)"
                            [disabled]="ButtonLoading || planButtonLoading[plan.id] || plan.isDemo || (hasActiveLicense && currentPackageType !== 'demo')"
                          >
                            <c-spinner
                              aria-hidden="true"
                              size="sm"
                              *ngIf="planButtonLoading[plan.id]"
                            ></c-spinner>
                            <span
                              *ngIf="
                                !planButtonLoading[plan.id] &&
                                selectedPlanId === plan.id &&
                                !plan.isDemo
                              "
                            >
                              <i class="fa fa-check me-1"></i> Selected Plan
                            </span>
                            <span
                              *ngIf="
                                !planButtonLoading[plan.id] &&
                                selectedPlanId !== plan.id &&
                                !plan.isDemo 
                              "
                            >
                              Choose {{ plan.planName }}
                              <span class="fw-bold ms-2">
                                {{ (getPlanTotal(plan) + getPlanAdditionalStorePrice(plan)) | currency }}
                              </span>
                            </span>
                            <span *ngIf="plan.isDemo">
                              <!-- <i class="fa fa-lock me-1"></i> Demo Plan Unavailable -->
                            </span>
                            <span *ngIf="planButtonLoading[plan.id]"
                              >Processing...</span
                            >
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <div class="col-12" *ngIf="!planLoading && !productPlans.length && plansError">
                    <div class="alert alert-warning mt-3">{{ plansError }}</div>
                  </div>
                  <div class="col-12" *ngIf="!planLoading && !productPlans.length && !plansError">
                    <div class="alert alert-info mt-3">
                      Plans are not yet available for this product. Please select a different product or try again later.
                    </div>
                  </div>
                </div>
              </div>
              <!-- ---------------------------------------------------------------------------------------------------------------------------- -->
            </c-col>
          </c-row>
        </div>
      </c-col>
    </c-row>
  </c-card-body>
</c-card>

<c-modal
  #verticallyCenteredModal
  alignment="center"
  id="verticallyCenteredModal"
>
  <c-modal-body>
    <div class="text-center">
      <h6>MO Number : {{ Momsg }}</h6>
      <h6>Item Number : {{ Itemmsg }}</h6>
      <h6>Message: {{ Issyncmsg }}</h6>
    </div>
    <hr />
    <h1 style="text-align: center">
      <div class="checkmark-circle">
        <div class="background"></div>
        <div class="checkmark draw"></div>
      </div>
    </h1>
  </c-modal-body>
  <c-modal-footer style="background-color: #1ab394">
    <button
      [cModalToggle]="verticallyCenteredModal.id"
      cButton
      color="secondary"
      (click)="NewProduction()"
    >
      Enter New Prouction
    </button>
  </c-modal-footer>
</c-modal>

<button
  id="openModalButtonff"
  [cModalToggle]="verticallyCenteredModalff.id"
  cButton
  style="display: none"
>
  Open Modal
</button>
<c-modal
  #verticallyCenteredModalff
  alignment="center"
  id="verticallyCenteredModalf"
>
  <c-modal-body>
    <hr />

    <div class="text-center">
      <h6>Message: {{ Mainmsg }}</h6>
    </div>
  </c-modal-body>
  <c-modal-footer>
    <button
      [cModalToggle]="verticallyCenteredModalff.id"
      cButton
      color="secondary"
      (click)="NewProduction()"
    >
      Close
    </button>
  </c-modal-footer>
</c-modal>

<c-modal
  #AddUserExtraInfo
  alignment="center"
  id="AddUserExtraInfo"
  backdrop="static"
  [visible]="ModalVisible"
  size="lg"
>
  <c-modal-body>
    <h5 cModalTitle>Business Information</h5>
    <p class="text-medium-emphasis">
      We need some extra information before you proceed further
    </p>
    <form
      cForm
      #RegisterForm="ngForm"
      [validated]="customStylesValidated"
      novalidate
      class="needs-validation"
      (ngSubmit)="
        AddUserCall(RegisterForm, UserData, UsersService.UserExtraInfoData)
      "
    >
      <!-- <c-row>
      <div class="text-start">
        <b class="text-medium-emphasis">Business Information</b>
      </div>
    </c-row> -->

      <c-row>
        <c-col lg="4">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon [cIcon]="icons.cilLibraryBuilding"></svg>
              </span>
              <input
                type="text"
                id="CompanyName"
                name="CompanyName"
                class="form-control"
                required
                (ngModelChange)="onCompanyNameChange($event)"
                [(ngModel)]="UsersService.UserExtraInfoData.companyName"
                placeholder="Company Name *"
              />
            </div>
            <!-- <div
            class="invalid-feedback"
            *ngIf="
              RegisterForm.controls.CompanyName.invalid &&
              RegisterForm.controls.CompanyName.touched
            "
          >
            Company Name is Required
          </div> -->
          </div>
        </c-col>
        <c-col lg="4">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon [cIcon]="icons.cilGlobeAlt"></svg>
              </span>
              <input
                type="text"
                id="WebsiteURL"
                name="WebsiteURL"
                class="form-control"
                placeholder="Website URL"
                [(ngModel)]="UsersService.UserExtraInfoData.url"
              />
            </div>
          </div>
        </c-col>
        <c-col lg="4">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg [cIcon]="icons.cilPhone"></svg>
              </span>
              <input
                type="text"
                id="PhoneNumber"
                name="PhoneNumber"
                pattern="^[0-9\s\(\)\+\-]+$"
                (keypress)="validatePhoneNumberInput($event)"
                class="form-control"
                (ngModelChange)="onPhoneNumberChange($event)"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.contactPersonPhone"
                placeholder="Phone Number *"
              />
            </div>
            <!-- <div
            class="invalid-feedback"
            *ngIf="
              RegisterForm.controls.PhoneNumber.invalid &&
              RegisterForm.controls.PhoneNumber.touched
            "
          >
            Phone Number is Required
          </div> -->
          </div>
        </c-col>
      </c-row>

      <c-row>
        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg [cIcon]="icons.cilBuilding"></svg>
              </span>
              <select
                id="BusinessType"
                name="BusinessType"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.businessType"
              >
                <option value="" disabled selected>Business Size</option>
                <option value="10-100">10-100 Employees</option>
                <option value="100-1000">100-1000 Employees</option>
                <option value="1000-10000">1000-10000 Employees</option>
                <option value="10000+">10000+ Employees</option>
              </select>
            </div>
            <!-- <div
            class="invalid-feedback"
            *ngIf="
              RegisterForm.controls.BusinessType.invalid &&
              RegisterForm.controls.BusinessType.touched
            "
          >
            Business Type is Required
          </div> -->
          </div>
        </c-col>
        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg [cIcon]="icons.cilIndustry"></svg>
              </span>
              <select
                id="Industry"
                name="Industry"
                class="form-control"
                [(ngModel)]="UsersService.UserExtraInfoData.industry"
                required
                placeholder=""
              >
                <option value="" disabled selected>Industry Focus *</option>
                <option value="Healthcare">Healthcare</option>
                <option value="Financial Services">Financial Services</option>
                <option value="Retail & E-commerce">Retail & E-commerce</option>
                <option value="Manufacturing">Manufacturing</option>
                <option value="Education">Education</option>
                <option value="Government & Public Sector">
                  Government & Public Sector
                </option>
                <option value="Nonprofits">Nonprofits</option>
                <option value="Legal Services">Legal Services</option>
                <option value="Construction & Engineering">
                  Construction & Engineering
                </option>
                <option value="Real Estate">Real Estate</option>
                <option value="Hospitality & Tourism">
                  Hospitality & Tourism
                </option>
                <option value="Transportation & Logistics">
                  Transportation & Logistics
                </option>
                <option value="Energy & Utilities">Energy & Utilities</option>
                <option value="Media & Entertainment">
                  Media & Entertainment
                </option>
                <option value="Technology & SaaS">Technology & SaaS</option>
                <option value="Telecommunications">Telecommunications</option>
                <option value="Agriculture">Agriculture</option>
                <option value="Professional Services">
                  Professional Services
                </option>
                <option value="Pharmaceuticals & Biotech">
                  Pharmaceuticals & Biotech
                </option>
                <option value="Other">Other (please specify)</option>
              </select>
            </div>
            <!-- <div
            class="invalid-feedback"
            *ngIf="
              RegisterForm.controls.Industry.invalid &&
              RegisterForm.controls.Industry.touched
            "
          >
            Industry is Required
          </div> -->
          </div>
        </c-col>
      </c-row>

      <!-- <c-row>
      <c-col lg="6">
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <svg cIcon [cIcon]="icons.cilMobile"></svg>
            </span>
            <input
              type="text"
              id="Mobile"
              name="Mobile"
              [(ngModel)]="
                UsersService.UserData.mobilePhoneNumber
              "
              class="form-control"
              required
              placeholder="Phone No."
            />
          </div>

          <div
              class="invalid-feedback"
              *ngIf="
                RegisterForm.controls.Mobile.invalid &&
                RegisterForm.controls.Mobile.touched
              "
            >
              Mobile No Required
            </div> 
        </div>
      </c-col>
       <c-col lg="6">
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <svg cIcon name="cilAddressBook"></svg>
            </span>
            <input
              type="text"
              id="JobbTitle"
              name="JobTitle"
              [(ngModel)]=""
              class="form-control"
              required
              placeholder="Company Name"
            />
          </div>
          <div
            class="invalid-feedback"
            *ngIf="RegisterForm.control.hasError('passwordMismatch')"
          >
            <label>Password and Confirm Password do not match.</label>
          </div>
        </div>
      </c-col> 
    </c-row> -->
      <!-- <c-row>
      <c-col lg="6">
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <svg cIcon name="cilLockLocked"></svg>
            </span>
            <input
              type="{{ showPassword ? 'text' : 'password' }}"
              id="Password"
              name="Password"
              [(ngModel)]="UsersService.UserData.password"
              class="form-control"
              autoComplete="new-password"
              required
              placeholder="Password"
              cFormControl
              pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*^#?&.(=)+-\s])([A-Za-z\d@$!%*^#?&.(=)+-\s]{8,})$"
              title="Hint: Minimum 8 characters i.e Lower & Upper case, Numbers and Special characters"
            />

            <button
              type="button"
              class="btn btn-light"
              (click)="togglePasswordVisibility()"
            >
              <img
                cIcon
                [src]="
                  showPassword
                    ? 'assets/images/avatars/hide.png'
                    : 'assets/images/avatars/show.png'
                "
              />
            </button>
          </div>
          <div
            class="text-danger"
            style="font-size: 12px"
            *ngIf="
              RegisterForm?.controls?.Password?.invalid &&
              RegisterForm?.controls?.Password?.touched
            "
          >
            Password must contain at least 8 characters including
            lowercase and uppercase letters, numbers, and special
            characters.
          </div>

          
        </div>
      </c-col>
      <c-col lg="6">
        <div class="mb-3">
          <div class="input-group">
            <span class="input-group-text">
              <svg cIcon name="cilLockLocked"></svg>
            </span>
            <input
              type="{{ showPassword ? 'text' : 'password' }}"
              id="ConfirmPassword"
              name="ConfirmPassword"
              class="form-control"
              autoComplete="new-ConfirmPassword"
              required
              [(ngModel)]="confirmPassword"
              #confirmPasswordField="ngModel"
              pattern="{{ UsersService.UserData.password }}"
              placeholder="Confirm Password"
            />
            <button
              type="button"
              class="btn btn-light"
              (click)="togglePasswordVisibility()"
            >
              <img
                cIcon
                [src]="
                  showPassword
                    ? 'assets/images/avatars/hide.png'
                    : 'assets/images/avatars/show.png'
                "
              />
            </button>
          </div>
          <div
            class="text-danger"
            style="font-size: 12px"
            *ngIf="
              RegisterForm?.controls?.ConfirmPassword?.errors
                ?.pattern
            "
          >
            Passwords must match.
          </div>
          
        </div>
      </c-col>
    </c-row> -->

      <c-row>
        <c-col lg="12">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilLocationPin"></svg>
              </span>
              <input
                type="text"
                id="StreetAddress"
                name="StreetAddress"
                class="form-control"
                required
                (ngModelChange)="onStreetAddressChange($event)"
                [(ngModel)]="UsersService.UserExtraInfoData.addr_Street"
                placeholder="Street Address *"
              />
            </div>
            <!-- <div
            class="invalid-feedback"
            *ngIf="
              RegisterForm.controls.StreetAddress.invalid &&
              RegisterForm.controls.StreetAddress.touched
            "
          >
            Street Address is Required
          </div> -->
          </div>
        </c-col>
      </c-row>
      <c-row>
        <c-col lg="12">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilLocationPin"></svg>
              </span>
              <input
                type="text"
                id="City"
                name="City"
                class="form-control"
                (ngModelChange)="onCityChange($event)"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.addr_City"
                placeholder="City *"
              />
              <input
                type="text"
                id="StateProvince"
                name="StateProvince"
                class="form-control"
                required
                (ngModelChange)="onStateChange($event)"
                [(ngModel)]="UsersService.UserExtraInfoData.addr_State"
                placeholder="State/Province *"
              />
              <input
                type="text"
                id="PostalZIPCode"
                name="PostalZIPCode"
                class="form-control"
                required
                (ngModelChange)="onZipCodeChange($event)"
                [(ngModel)]="UsersService.UserExtraInfoData.addr_ZipCode"
                placeholder="Postal/ZIP Code *"
              />
              <select
                id="Country"
                name="Country"
                (ngModelChange)="onCountryChange($event)"
                class="form-control"
                [(ngModel)]="UsersService.UserExtraInfoData.addr_Country"
                required
              >
                <option value="" disabled selected>Country *</option>
                <option value="USA">USA</option>
                <option value="Canada">Canada</option>

                <option value="Afghanistan">Afghanistan</option>
                <option value="Albania">Albania</option>
                <option value="Algeria">Algeria</option>
                <option value="Andorra">Andorra</option>
                <option value="Angola">Angola</option>
                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                <option value="Argentina">Argentina</option>
                <option value="Armenia">Armenia</option>
                <option value="Australia">Australia</option>
                <option value="Austria">Austria</option>
                <option value="Azerbaijan">Azerbaijan</option>
                <option value="Bahamas">Bahamas</option>
                <option value="Bahrain">Bahrain</option>
                <option value="Bangladesh">Bangladesh</option>
                <option value="Barbados">Barbados</option>
                <option value="Belarus">Belarus</option>
                <option value="Belgium">Belgium</option>
                <option value="Belize">Belize</option>
                <option value="Benin">Benin</option>
                <option value="Bhutan">Bhutan</option>
                <option value="Bolivia">Bolivia</option>
                <option value="Bosnia and Herzegovina">
                  Bosnia and Herzegovina
                </option>
                <option value="Botswana">Botswana</option>
                <option value="Brazil">Brazil</option>
                <option value="Brunei">Brunei</option>
                <option value="Bulgaria">Bulgaria</option>
                <option value="Burkina Faso">Burkina Faso</option>
                <option value="Burundi">Burundi</option>
                <option value="Cambodia">Cambodia</option>
                <option value="Cameroon">Cameroon</option>
                <option value="Canada">Canada</option>
                <option value="Cape Verde">Cape Verde</option>
                <option value="Central African Republic">
                  Central African Republic
                </option>
                <option value="Chad">Chad</option>
                <option value="Chile">Chile</option>
                <option value="China">China</option>
                <option value="Colombia">Colombia</option>
                <option value="Comoros">Comoros</option>
                <option value="Congo">Congo</option>
                <option value="Costa Rica">Costa Rica</option>
                <option value="Croatia">Croatia</option>
                <option value="Cuba">Cuba</option>
                <option value="Cyprus">Cyprus</option>
                <option value="Czech Republic">Czech Republic</option>
                <option value="Denmark">Denmark</option>
                <option value="Djibouti">Djibouti</option>
                <option value="Dominica">Dominica</option>
                <option value="Dominican Republic">Dominican Republic</option>
                <option value="Ecuador">Ecuador</option>
                <option value="Egypt">Egypt</option>
                <option value="El Salvador">El Salvador</option>
                <option value="Equatorial Guinea">Equatorial Guinea</option>
                <option value="Eritrea">Eritrea</option>
                <option value="Estonia">Estonia</option>
                <option value="Eswatini">Eswatini</option>
                <option value="Ethiopia">Ethiopia</option>
                <option value="Fiji">Fiji</option>
                <option value="Finland">Finland</option>
                <option value="France">France</option>
                <option value="Gabon">Gabon</option>
                <option value="Gambia">Gambia</option>
                <option value="Georgia">Georgia</option>
                <option value="Germany">Germany</option>
                <option value="Ghana">Ghana</option>
                <option value="Greece">Greece</option>
                <option value="Grenada">Grenada</option>
                <option value="Guatemala">Guatemala</option>
                <option value="Guinea">Guinea</option>
                <option value="Guyana">Guyana</option>
                <option value="Haiti">Haiti</option>
                <option value="Honduras">Honduras</option>
                <option value="Hungary">Hungary</option>
                <option value="Iceland">Iceland</option>
                <option value="India">India</option>
                <option value="Indonesia">Indonesia</option>
                <option value="Iran">Iran</option>
                <option value="Iraq">Iraq</option>
                <option value="Ireland">Ireland</option>
                <option value="Israel">Israel</option>
                <option value="Italy">Italy</option>
                <option value="Jamaica">Jamaica</option>
                <option value="Japan">Japan</option>
                <option value="Jordan">Jordan</option>
                <option value="Kazakhstan">Kazakhstan</option>
                <option value="Kenya">Kenya</option>
                <option value="Kuwait">Kuwait</option>
                <option value="Kyrgyzstan">Kyrgyzstan</option>
                <option value="Laos">Laos</option>
                <option value="Latvia">Latvia</option>
                <option value="Lebanon">Lebanon</option>
                <option value="Lesotho">Lesotho</option>
                <option value="Liberia">Liberia</option>
                <option value="Libya">Libya</option>
                <option value="Liechtenstein">Liechtenstein</option>
                <option value="Lithuania">Lithuania</option>
                <option value="Luxembourg">Luxembourg</option>
                <option value="Madagascar">Madagascar</option>
                <option value="Malawi">Malawi</option>
                <option value="Malaysia">Malaysia</option>
                <option value="Maldives">Maldives</option>
                <option value="Mali">Mali</option>
                <option value="Malta">Malta</option>
                <option value="Mauritania">Mauritania</option>
                <option value="Mauritius">Mauritius</option>
                <option value="Mexico">Mexico</option>
                <option value="Moldova">Moldova</option>
                <option value="Monaco">Monaco</option>
                <option value="Mongolia">Mongolia</option>
                <option value="Montenegro">Montenegro</option>
                <option value="Morocco">Morocco</option>
                <option value="Mozambique">Mozambique</option>
                <option value="Myanmar">Myanmar</option>
                <option value="Namibia">Namibia</option>
                <option value="Nepal">Nepal</option>
                <option value="Netherlands">Netherlands</option>
                <option value="New Zealand">New Zealand</option>
                <option value="Nicaragua">Nicaragua</option>
                <option value="Niger">Niger</option>
                <option value="Nigeria">Nigeria</option>
                <option value="North Korea">North Korea</option>
                <option value="North Macedonia">North Macedonia</option>
                <option value="Norway">Norway</option>
                <option value="Oman">Oman</option>
                <option value="Pakistan">Pakistan</option>
                <option value="Panama">Panama</option>
                <option value="Papua New Guinea">Papua New Guinea</option>
                <option value="Paraguay">Paraguay</option>
                <option value="Peru">Peru</option>
                <option value="Philippines">Philippines</option>
                <option value="Poland">Poland</option>
                <option value="Portugal">Portugal</option>
                <option value="Qatar">Qatar</option>
                <option value="Romania">Romania</option>
                <option value="Russia">Russia</option>
                <option value="Rwanda">Rwanda</option>
                <option value="Saudi Arabia">Saudi Arabia</option>
                <option value="Senegal">Senegal</option>
                <option value="Serbia">Serbia</option>
                <option value="Singapore">Singapore</option>
                <option value="Slovakia">Slovakia</option>
                <option value="Slovenia">Slovenia</option>
                <option value="South Africa">South Africa</option>
                <option value="South Korea">South Korea</option>
                <option value="Spain">Spain</option>
                <option value="Sri Lanka">Sri Lanka</option>
                <option value="Sudan">Sudan</option>
                <option value="Sweden">Sweden</option>
                <option value="Switzerland">Switzerland</option>
                <option value="Syria">Syria</option>
                <option value="Taiwan">Taiwan</option>
                <option value="Tajikistan">Tajikistan</option>
                <option value="Tanzania">Tanzania</option>
                <option value="Thailand">Thailand</option>
                <option value="Tunisia">Tunisia</option>
                <option value="Turkey">Turkey</option>
                <option value="Uganda">Uganda</option>
                <option value="Ukraine">Ukraine</option>
                <option value="United Arab Emirates">
                  United Arab Emirates
                </option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="United States">United States</option>
                <option value="Uruguay">Uruguay</option>
                <option value="Uzbekistan">Uzbekistan</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Vietnam">Vietnam</option>
                <option value="Yemen">Yemen</option>
                <option value="Zambia">Zambia</option>
                <option value="Zimbabwe">Zimbabwe</option>
              </select>
            </div>
            <!-- <div
            class="invalid-feedback"
            *ngIf="
              RegisterForm.controls.StreetAddress.invalid &&
              RegisterForm.controls.StreetAddress.touched
            "
          >
            Street Address is Required
          </div> -->
          </div>
        </c-col>
      </c-row>

      <c-row>
        <div class="input-group">
          <c-form-check [switch]="true">
            <input
              cFormCheckInput
              type="checkbox"
              id="EditBillingInfo"
              name="EditBillingInfo"
              [(ngModel)]="EditBillingInfo"
              (click)="onChangeBillingInformation($event)"
            />
            <label cFormCheckLabel style="font-size: 14px"
              >Change Billing Address.</label
            >
          </c-form-check>
        </div>
      </c-row>
      <c-row>
        <div class="text-start">
          <b class="text-medium-emphasis">Billing Information</b>
        </div>
      </c-row>
      <c-row>
        <c-col lg="12">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilUser"></svg>
              </span>
              <input
                type="text"
                id="legalName"
                name="legalName"
                [(ngModel)]="UsersService.BusinessInfoData.legalName"
                class="form-control"
                required
                placeholder="Legal Name"
                [disabled]="!EditBillingInfo"
              />
            </div>
          </div>
        </c-col>
      </c-row>
      <c-row>
        <c-col lg="12">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilLocationPin"></svg>
              </span>
              <input
                type="text"
                id="addressLine1"
                name="addressLine1"
                [(ngModel)]="UsersService.BusinessInfoData.streetAddr"
                class="form-control"
                [disabled]="!EditBillingInfo"
                required
                placeholder="Address Line 1"
              />
            </div>
          </div>
        </c-col>
      </c-row>
      <c-row>
        <c-col lg="12">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilLocationPin"></svg>
              </span>
              <input
                type="text"
                id="city"
                name="city"
                [(ngModel)]="UsersService.BusinessInfoData.city"
                [disabled]="!EditBillingInfo"
                class="form-control"
                required
                placeholder="City"
              />
              <input
                type="text"
                id="state"
                name="state"
                [(ngModel)]="UsersService.BusinessInfoData.state"
                [disabled]="!EditBillingInfo"
                class="form-control"
                required
                placeholder="State/Province"
              />
              <input
                type="text"
                id="zipCode"
                name="zipCode"
                [(ngModel)]="UsersService.BusinessInfoData.zipCode"
                [disabled]="!EditBillingInfo"
                class="form-control"
                required
                placeholder="Postal/ZIP Code"
              />
              <select
                id="country"
                name="country"
                [disabled]="!EditBillingInfo"
                class="form-control"
                [(ngModel)]="UsersService.BusinessInfoData.country"
                required
              >
                <option value="" disabled selected>Country</option>
                <option value="USA">USA</option>
                <option value="Canada">Canada</option>

                <option value="Afghanistan">Afghanistan</option>
                <option value="Albania">Albania</option>
                <option value="Algeria">Algeria</option>
                <option value="Andorra">Andorra</option>
                <option value="Angola">Angola</option>
                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                <option value="Argentina">Argentina</option>
                <option value="Armenia">Armenia</option>
                <option value="Australia">Australia</option>
                <option value="Austria">Austria</option>
                <option value="Azerbaijan">Azerbaijan</option>
                <option value="Bahamas">Bahamas</option>
                <option value="Bahrain">Bahrain</option>
                <option value="Bangladesh">Bangladesh</option>
                <option value="Barbados">Barbados</option>
                <option value="Belarus">Belarus</option>
                <option value="Belgium">Belgium</option>
                <option value="Belize">Belize</option>
                <option value="Benin">Benin</option>
                <option value="Bhutan">Bhutan</option>
                <option value="Bolivia">Bolivia</option>
                <option value="Bosnia and Herzegovina">
                  Bosnia and Herzegovina
                </option>
                <option value="Botswana">Botswana</option>
                <option value="Brazil">Brazil</option>
                <option value="Brunei">Brunei</option>
                <option value="Bulgaria">Bulgaria</option>
                <option value="Burkina Faso">Burkina Faso</option>
                <option value="Burundi">Burundi</option>
                <option value="Cambodia">Cambodia</option>
                <option value="Cameroon">Cameroon</option>
                <option value="Canada">Canada</option>
                <option value="Cape Verde">Cape Verde</option>
                <option value="Central African Republic">
                  Central African Republic
                </option>
                <option value="Chad">Chad</option>
                <option value="Chile">Chile</option>
                <option value="China">China</option>
                <option value="Colombia">Colombia</option>
                <option value="Comoros">Comoros</option>
                <option value="Congo">Congo</option>
                <option value="Costa Rica">Costa Rica</option>
                <option value="Croatia">Croatia</option>
                <option value="Cuba">Cuba</option>
                <option value="Cyprus">Cyprus</option>
                <option value="Czech Republic">Czech Republic</option>
                <option value="Denmark">Denmark</option>
                <option value="Djibouti">Djibouti</option>
                <option value="Dominica">Dominica</option>
                <option value="Dominican Republic">Dominican Republic</option>
                <option value="Ecuador">Ecuador</option>
                <option value="Egypt">Egypt</option>
                <option value="El Salvador">El Salvador</option>
                <option value="Equatorial Guinea">Equatorial Guinea</option>
                <option value="Eritrea">Eritrea</option>
                <option value="Estonia">Estonia</option>
                <option value="Eswatini">Eswatini</option>
                <option value="Ethiopia">Ethiopia</option>
                <option value="Fiji">Fiji</option>
                <option value="Finland">Finland</option>
                <option value="France">France</option>
                <option value="Gabon">Gabon</option>
                <option value="Gambia">Gambia</option>
                <option value="Georgia">Georgia</option>
                <option value="Germany">Germany</option>
                <option value="Ghana">Ghana</option>
                <option value="Greece">Greece</option>
                <option value="Grenada">Grenada</option>
                <option value="Guatemala">Guatemala</option>
                <option value="Guinea">Guinea</option>
                <option value="Guyana">Guyana</option>
                <option value="Haiti">Haiti</option>
                <option value="Honduras">Honduras</option>
                <option value="Hungary">Hungary</option>
                <option value="Iceland">Iceland</option>
                <option value="India">India</option>
                <option value="Indonesia">Indonesia</option>
                <option value="Iran">Iran</option>
                <option value="Iraq">Iraq</option>
                <option value="Ireland">Ireland</option>
                <option value="Israel">Israel</option>
                <option value="Italy">Italy</option>
                <option value="Jamaica">Jamaica</option>
                <option value="Japan">Japan</option>
                <option value="Jordan">Jordan</option>
                <option value="Kazakhstan">Kazakhstan</option>
                <option value="Kenya">Kenya</option>
                <option value="Kuwait">Kuwait</option>
                <option value="Kyrgyzstan">Kyrgyzstan</option>
                <option value="Laos">Laos</option>
                <option value="Latvia">Latvia</option>
                <option value="Lebanon">Lebanon</option>
                <option value="Lesotho">Lesotho</option>
                <option value="Liberia">Liberia</option>
                <option value="Libya">Libya</option>
                <option value="Liechtenstein">Liechtenstein</option>
                <option value="Lithuania">Lithuania</option>
                <option value="Luxembourg">Luxembourg</option>
                <option value="Madagascar">Madagascar</option>
                <option value="Malawi">Malawi</option>
                <option value="Malaysia">Malaysia</option>
                <option value="Maldives">Maldives</option>
                <option value="Mali">Mali</option>
                <option value="Malta">Malta</option>
                <option value="Mauritania">Mauritania</option>
                <option value="Mauritius">Mauritius</option>
                <option value="Mexico">Mexico</option>
                <option value="Moldova">Moldova</option>
                <option value="Monaco">Monaco</option>
                <option value="Mongolia">Mongolia</option>
                <option value="Montenegro">Montenegro</option>
                <option value="Morocco">Morocco</option>
                <option value="Mozambique">Mozambique</option>
                <option value="Myanmar">Myanmar</option>
                <option value="Namibia">Namibia</option>
                <option value="Nepal">Nepal</option>
                <option value="Netherlands">Netherlands</option>
                <option value="New Zealand">New Zealand</option>
                <option value="Nicaragua">Nicaragua</option>
                <option value="Niger">Niger</option>
                <option value="Nigeria">Nigeria</option>
                <option value="North Korea">North Korea</option>
                <option value="North Macedonia">North Macedonia</option>
                <option value="Norway">Norway</option>
                <option value="Oman">Oman</option>
                <option value="Pakistan">Pakistan</option>
                <option value="Panama">Panama</option>
                <option value="Papua New Guinea">Papua New Guinea</option>
                <option value="Paraguay">Paraguay</option>
                <option value="Peru">Peru</option>
                <option value="Philippines">Philippines</option>
                <option value="Poland">Poland</option>
                <option value="Portugal">Portugal</option>
                <option value="Qatar">Qatar</option>
                <option value="Romania">Romania</option>
                <option value="Russia">Russia</option>
                <option value="Rwanda">Rwanda</option>
                <option value="Saudi Arabia">Saudi Arabia</option>
                <option value="Senegal">Senegal</option>
                <option value="Serbia">Serbia</option>
                <option value="Singapore">Singapore</option>
                <option value="Slovakia">Slovakia</option>
                <option value="Slovenia">Slovenia</option>
                <option value="South Africa">South Africa</option>
                <option value="South Korea">South Korea</option>
                <option value="Spain">Spain</option>
                <option value="Sri Lanka">Sri Lanka</option>
                <option value="Sudan">Sudan</option>
                <option value="Sweden">Sweden</option>
                <option value="Switzerland">Switzerland</option>
                <option value="Syria">Syria</option>
                <option value="Taiwan">Taiwan</option>
                <option value="Tajikistan">Tajikistan</option>
                <option value="Tanzania">Tanzania</option>
                <option value="Thailand">Thailand</option>
                <option value="Tunisia">Tunisia</option>
                <option value="Turkey">Turkey</option>
                <option value="Uganda">Uganda</option>
                <option value="Ukraine">Ukraine</option>
                <option value="United Arab Emirates">
                  United Arab Emirates
                </option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="United States">United States</option>
                <option value="Uruguay">Uruguay</option>
                <option value="Uzbekistan">Uzbekistan</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Vietnam">Vietnam</option>
                <option value="Yemen">Yemen</option>
                <option value="Zambia">Zambia</option>
                <option value="Zimbabwe">Zimbabwe</option>
              </select>
            </div>
            <!-- <div
            class="invalid-feedback"
            *ngIf="
              RegisterForm.controls.StreetAddress.invalid &&
              RegisterForm.controls.StreetAddress.touched
            "
          >
            Street Address is Required
          </div> -->
          </div>
        </c-col>
      </c-row>

      <c-row>
        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilEnvelopeClosed"></svg>
              </span>
              <input
                type="email"
                id="billingEmail"
                name="billingEmail"
                [(ngModel)]="UsersService.BusinessInfoData.emailAddress"
                class="form-control"
                required
                placeholder="Billing Email"
                [disabled]="!EditBillingInfo"
              />
            </div>
          </div>
        </c-col>
        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg [cIcon]="icons.cilPhone"></svg>
              </span>
              <input
                type="text"
                id="billingPhoneNumber"
                name="billingPhoneNumber"
                pattern="^[0-9\s\(\)\+\-]+$"
                (keypress)="validatePhoneNumberInput($event)"
                class="form-control"
                required
                [(ngModel)]="UsersService.BusinessInfoData.phoneNo"
                placeholder="Billing Phone Number"
                [disabled]="!EditBillingInfo"
              />
            </div>
          </div>
        </c-col>
      </c-row>

      <div *ngIf="msg">
        <div>{{ msg }}</div>
      </div>
      <div class="text-end">

        <button
          type="button"
          (click)="toggleModal()"
          class="btn btn-secondary px-4 mb-3 mt-2 "
          style="margin: auto; margin-right:10px;"
          [disabled]="ButtonLoading"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary px-4 mb-3 mt-2"
          style="margin: auto"
          [disabled]="ButtonLoading"
        >
          <c-spinner
            aria-hidden="true"
            size="sm"
            *ngIf="ButtonLoading"
          ></c-spinner>
          Save
        </button>
        <!-- <button
          class="btn btn-primary px-4 mb-3 mt-2 mx-2"
          style="margin: auto"
          (click)="logout()"
        >
          <c-spinner
            aria-hidden="true"
            size="sm"
            *ngIf="ButtonLoading"
          ></c-spinner>
          Logout
        </button> -->
      </div>
    </form>
  </c-modal-body>
</c-modal>

<!-- Pay Now Modal -->
<c-modal
  id="PayNowModal"
  [visible]="visiblePayNowModal"
  backdrop="static"
  alignment="center"
  size="lg"
>
  <c-modal-header>
    <h6 cModalTitle>Enter Card Details</h6>
    <button (click)="CancelPlanPurchase()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <form
      [formGroup]="payNowForm"
      (ngSubmit)="onPayNowSubmit()"
      cForm
      [gutter]="2"
      cRow
    >
      <c-col [md]="12">
        <div class="text-start">
          <b class="text-medium-emphasis">Card Details</b>
        </div>
      </c-col>

      <!-- First Name and Last Name -->
      <c-col [md]="6">
        <div class="form-group">
          <label for="payNowFirstName">First Name *</label>
          <input
            type="text"
            id="payNowFirstName"
            formControlName="firstName"
            class="form-control"
            placeholder="First Name"
          />
          <div
            *ngIf="payNowForm.get('firstName')?.touched && payNowForm.get('firstName')?.invalid"
            class="text-danger"
          >
            First Name is required.
          </div>
        </div>
      </c-col>
      <c-col [md]="6">
        <div class="form-group">
          <label for="payNowLastName">Last Name *</label>
          <input
            type="text"
            id="payNowLastName"
            formControlName="lastName"
            class="form-control"
            placeholder="Last Name"
          />
          <div
            *ngIf="payNowForm.get('lastName')?.touched && payNowForm.get('lastName')?.invalid"
            class="text-danger"
          >
            Last Name is required.
          </div>
        </div>
      </c-col>

      <!-- Card Number -->
      <c-col [md]="4">
        <div class="form-group">
          <label for="payNowCardNumber">Card Number *</label>
          <input
            type="text"
            id="payNowCardNumber"
            formControlName="cardNumber"
            class="form-control"
            placeholder="Enter Card Number"
            maxlength="16"
          />
          <div
            *ngIf="payNowForm.get('cardNumber')?.touched && payNowForm.get('cardNumber')?.invalid"
            class="text-danger"
          >
            Card Number is required and must be 16 digits.
          </div>
        </div>
      </c-col>

      <!-- Expiry Month -->
      <c-col [md]="3">
        <div class="form-group">
          <label for="payNowExpiryMonth">Expiry Month (MM) *</label>
          <input
            type="text"
            id="payNowExpiryMonth"
            formControlName="expiryMonth"
            class="form-control"
            placeholder="MM"
            maxlength="2"
          />
          <div
            *ngIf="payNowForm.get('expiryMonth')?.touched && payNowForm.get('expiryMonth')?.invalid"
            class="text-danger"
          >
            Expiry Month is required (01-12).
          </div>
        </div>
      </c-col>

      <!-- Expiry Year -->
      <c-col [md]="3">
        <div class="form-group">
          <label for="payNowExpiryYear">Expiry Year (YY) *</label>
          <input
            type="text"
            id="payNowExpiryYear"
            formControlName="expiryYear"
            class="form-control"
            placeholder="YY"
            maxlength="2"
          />
          <div
            *ngIf="payNowForm.get('expiryYear')?.touched && payNowForm.get('expiryYear')?.invalid"
            class="text-danger"
          >
            Expiry Year is required.
          </div>
        </div>
      </c-col>

      <!-- CVV -->
      <c-col [md]="2">
        <div class="form-group">
          <label for="payNowCvv">CVV Code *</label>
          <input
            type="password"
            id="payNowCvv"
            formControlName="cvv"
            class="form-control"
            placeholder="CVV"
            maxlength="3"
          />
          <div
            *ngIf="payNowForm.get('cvv')?.touched && payNowForm.get('cvv')?.invalid"
            class="text-danger"
          >
            CVV is required (3 digits).
          </div>
        </div>
      </c-col>

      <!-- Billing Address Section -->
      <c-col [md]="12">
        <div class="text-start">
          <b class="text-medium-emphasis">Billing Address</b>
          <div class="input-group">
            <c-form-check [switch]="true">
              <input
                cFormCheckInput
                type="checkbox"
                id="editBillingAddressPayNow"
                [(ngModel)]="EditBillingAddressOnCard"
                [ngModelOptions]="{standalone: true}"
                (change)="onChangeBillingAddressOnCard($event)"
              />
              <label cFormCheckLabel style="font-size: 14px">
                Change Billing Address On Card
              </label>
            </c-form-check>
          </div>
        </div>
      </c-col>

      <!-- Address Line 1 -->
      <c-col [md]="12">
        <div class="form-group">
          <label for="payNowAddressLine1">Address *</label>
          <input
            type="text"
            id="payNowAddressLine1"
            formControlName="addressLine1"
            class="form-control"
            placeholder="Address Line 1"
          />
          <div
            *ngIf="payNowForm.get('addressLine1')?.touched && payNowForm.get('addressLine1')?.invalid"
            class="text-danger"
          >
            Address is required.
          </div>
        </div>
      </c-col>

      <!-- State, City, Zip, Country -->
      <c-col [md]="3">
        <div class="form-group">
          <label for="payNowState">State *</label>
          <input
            type="text"
            id="payNowState"
            formControlName="state"
            class="form-control"
            placeholder="State"
          />
          <div
            *ngIf="payNowForm.get('state')?.touched && payNowForm.get('state')?.invalid"
            class="text-danger"
          >
            State is required.
          </div>
        </div>
      </c-col>
      <c-col [md]="3">
        <div class="form-group">
          <label for="payNowCity">City *</label>
          <input
            type="text"
            id="payNowCity"
            formControlName="city"
            class="form-control"
            placeholder="City"
          />
          <div
            *ngIf="payNowForm.get('city')?.touched && payNowForm.get('city')?.invalid"
            class="text-danger"
          >
            City is required.
          </div>
        </div>
      </c-col>
      <c-col [md]="3">
        <div class="form-group">
          <label for="payNowZipCode">Zip/Postal Code *</label>
          <input
            type="text"
            id="payNowZipCode"
            formControlName="zipCode"
            class="form-control"
            placeholder="Zip Code"
          />
          <div
            *ngIf="payNowForm.get('zipCode')?.touched && payNowForm.get('zipCode')?.invalid"
            class="text-danger"
          >
            Zip Code is required.
          </div>
        </div>
      </c-col>
      <c-col [md]="3">
        <div class="form-group">
          <label for="payNowCountry">Country *</label>
          <input
            type="text"
            id="payNowCountry"
            formControlName="country"
            class="form-control"
            placeholder="Country"
          />
          <div
            *ngIf="payNowForm.get('country')?.touched && payNowForm.get('country')?.invalid"
            class="text-danger"
          >
            Country is required.
          </div>
        </div>
      </c-col>

      <!-- Order Summary -->
      <c-col [md]="12" class="mt-3">
        <div class="card bg-light">
          <div class="card-body">
            <div class="d-flex justify-content-between fw-bold">
              <span>Total Amount:</span>
              <span>{{ totalPriceWithAdditionalStore | currency }}</span>
            </div>
          </div>
        </div>
      </c-col>

      <!-- Submit Button -->
      <div class="form-group text-center mt-3">
        <button
          type="button"
          (click)="CancelPlanPurchase()"
          class="btn btn-secondary me-2"
          [disabled]="PayNowButtonLoading"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="payNowForm.invalid || PayNowButtonLoading"
        >
          <c-spinner
            aria-hidden="true"
            size="sm"
            *ngIf="PayNowButtonLoading"
          ></c-spinner>
          Pay Now
        </button>
      </div>
    </form>
  </c-modal-body>
</c-modal>
